import { createContext, useContext } from "react";
import { useAIAssessmentState } from "./useAIAssessmentState";

const AIAssessmentContext = createContext<ReturnType<
  typeof useAIAssessmentState
> | null>(null);

export const AIAssessmentProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const state = useAIAssessmentState();
  return (
    <AIAssessmentContext.Provider value={state}>
      {children}
    </AIAssessmentContext.Provider>
  );
};

export const useAIAssessmentContext = () => {
  const context = useContext(AIAssessmentContext);
  if (!context)
    throw new Error(
      "useAIAssessmentContext must be used within a AIAssessmentProvider"
    );
  return context;
};
